import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface Props {
  from?: string | null;
  to?: string | null;
}

export const useCompanyEngagement = ({ from, to }: Props) => {
  return useQuery({
    queryKey: ['crm/messages/company-engagement', from, to],
    queryFn: async () => {
      const response: iResponse<Engagement[]> = await fetchAPI({
        method: 'GET',
        route: 'crm/messages/company-engagement',
        queryString: `from=${from}&to=${to}`
      });
      return response;
    },
    enabled: !!from && !!to
  });
};

export default useCompanyEngagement;
